import { cn } from '@/utils/style';
import UpcomingIcon from '../../../../public/images/medicine-dictionary/upcoming.svg';

const DiseaseEncyclopediaEmptyState = () => {
  return (
    <section className={cn('flex flex-col items-center justify-center gap-[20px] py-[120px]')}>
      <div className='flex justify-center'>
        <UpcomingIcon className='h-[48px] w-[48px]' />
      </div>
      <div className='flex flex-col gap-[8px]'>
        <h2 className={cn('typography-ui-20sb text-center text-gray-700')}>찾으시는 정보가 없어요</h2>
        <p className={cn('typography-ui-15r text-center text-gray-400')}>
          질환 이름과 증상을 다시 확인하고
          <br />
          검색해주세요.
        </p>
      </div>
    </section>
  );
};

export default DiseaseEncyclopediaEmptyState;
